import Table from 'components/table/Table'
import TableCheckBox from 'components/table/TableCheckBox'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { setSelected } from 'features/keywordPlanner/predictKeywordSlice'
import KeywordStat from 'features/keywordPlanner/KeywordStat'
import classNames from 'classnames'

const PredictKeywordItem = ({ keyword }) => {
  const dispatch = useDispatch()
  const { selected, content, registered } = useSelector(
    state => state.keywordPlanner.predictKeyword
  )
  const stats = content.find(item => item.keyword === keyword)?.data
  const mobile = stats?.MOBILE
  const pc = stats?.PC

  const handleChecked = () => {
    dispatch(setSelected(keyword))
  }

  return (
    <Table.Row
      key={keyword}
      rowId={keyword}
      hoverClassName="over"
      className={classNames({ on: selected.includes(keyword) })}>
      <td className="align_c">
        <div className="inner_tbl">
          <TableCheckBox
            checked={selected.includes(keyword)}
            onCheckedChange={handleChecked}
          />
        </div>
      </td>
      <td>
        <div className="inner_tbl">
          <div className="regist_word">
            <div className="detail_word">{keyword}</div>
            {registered.includes(keyword) && (
              <div className="info_word">
                <span className="txt_badge">등록키워드</span>
              </div>
            )}
          </div>
        </div>
      </td>
      <td className="align_r">
        <div className="inner_tbl">
          <KeywordStat data={mobile} field="bidRequest" />
        </div>
      </td>
      <td className="align_r line_c">
        <div className="inner_tbl">
          <KeywordStat data={mobile} field="click" />
        </div>
      </td>
      <td className="align_r line_c">
        <div className="inner_tbl">
          <KeywordStat data={mobile} field="bidAmount" />
        </div>
      </td>
      <td className="align_r line_c">
        <div className="inner_tbl">
          <KeywordStat data={mobile} field="rank" />
        </div>
      </td>
      <td className="align_r">
        <div className="inner_tbl">
          <KeywordStat data={pc} field="bidRequest" />
        </div>
      </td>
      <td className="align_r line_c">
        <div className="inner_tbl">
          <KeywordStat data={pc} field="click" />
        </div>
      </td>
      <td className="align_r line_c">
        <div className="inner_tbl">
          <KeywordStat data={pc} field="bidAmount" />
        </div>
      </td>
      <td className="align_r line_c">
        <div className="inner_tbl">
          <KeywordStat data={pc} field="rank" />
        </div>
      </td>
    </Table.Row>
  )
}
export default PredictKeywordItem
PredictKeywordItem.propTypes = {
  keyword: PropTypes.string,
}
